import {ObjectionStatuses} from '../enums/objection-statuses';

export class ObjectionStatusHistory {
  id!: number;
  status!: ObjectionStatuses;
  remark!: string;
  created_at: Date = new Date();
  updated_at: Date = new Date();
}
